import type { ScenePlanDialect } from '@toolproof-core/lib/_contract/scene-plan';

import { primitivePointerSweepSchema, primitiveScenePlanTargetSchema } from '../_contract/_@schema/scenePlan';

export const primitiveScenePlanDialect = {
    targetSchema: primitiveScenePlanTargetSchema,
    extensions: [{
        schema: primitivePointerSweepSchema,
        constraint: { effectKind: 'pointer-sweep', targetFields: ['target'], maximumPerSegment: 1, stationary: true },
    }],
} satisfies ScenePlanDialect;
